angular
    .module("skillBuilderSaaS")
    .filter("slugify", function () {
    return function (input) {
        if (!input)
            return input;
        // make lower case and trim
        var slug = input.toLowerCase().trim();
        // replace invalid chars with empty space
        slug = slug.replace(/[^a-z0-9\s-]/g, "");
        // replace multiple spaces or hyphens with a single hyphen
        slug = slug.replace(/[\s-]+/g, "-");
        return slug;
    };
});
